import { useMutation } from "@tanstack/react-query";

import { useAppState } from "../context/StateContext";
import UserService from "../services/user.service";
import { getBrandByCompanyName } from "../util/brands";
import useCurrentBrand from "./useCurrentBrand";

const useActionSyncUser = () => {
  const { currentUser, setCurrentUser } = useAppState();
  const { setCurrentBrand } = useCurrentBrand();

  const isBrandingEnabled = process.env.IS_BRANDING_ENABLED === "true";

  return useMutation(["user.sync"], () => UserService.getCurrentUser(currentUser?.email), {
    onSuccess: (response) => {
      if (response && response.data) {
        const { id } = response.data.company;

        if (isBrandingEnabled) setCurrentBrand(getBrandByCompanyName(id!));

        setCurrentUser({
          ...response.data,
        });

        if (currentUser?.company?.id !== id) {
          location.reload();
          location.replace("/");
        }
      }
    },
    onError: () => {},
  });
};

export default useActionSyncUser;
